import { useState, useEffect } from 'react';
import { getUserFilesv2 } from '../../../shared/services/apiGateway';

function useUserFilesv2(userid = '') {
  const [userFiles, setUserFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    const abortController = new AbortController();
    let ignore = false;

    async function fetchData() {
      try {
        setIsError(false);
        setIsLoading(true);
        const response = await getUserFilesv2(userid, null, abortController.signal);
        if (!ignore && response !== 'aborted' && response) {
          const normalizedFiles = response.map((file) => ({
            ...file,
            sortableFundValue: file.vintageFundNames ? file.vintageFundNames.sort().join(' ') : file.fundName,
            id: file?.id,
          }));
          setUserFiles(normalizedFiles);
        }
      } catch (error) {
        if (error.name !== 'AbortError') {
          if (error.statusCode === 500) {
            // redirect to old
            window.location.href = '/funds/statements/old';
          }
          setIsError(true);
        }
      } finally {
        setIsLoading(false);
      }
    }

    fetchData();

    return () => {
      ignore = true;
      abortController.abort();
    };
  }, [userid]);

  return { userFiles, isLoading, isError };
}

export default useUserFilesv2;
